import { registerLocaleData } from "@angular/common";
import localeDe from "@angular/common/locales/de";
import localeDeExtra from "@angular/common/locales/extra/de";
import { LOCALE_ID } from "@angular/core";

registerLocaleData(localeDe, "de-AT", localeDeExtra);

export const localeProvider = { provide: LOCALE_ID, useValue: "de-AT" };
